import { SnowplowHelper } from './helpers/snowplow_helper';
import FullstoryProvider from './providers/fullstory';
import ProviderWrapper from './providers/provider_wrapper';
import TealiumProvider from './providers/tealium';

export const PROVIDERS = [FullstoryProvider, TealiumProvider];

export function loadProviders(
  { configs = {}, log, providers = PROVIDERS }: Record<any, any>,
  snowplowHelper: SnowplowHelper | null = null,
) {
  const activeProviders: any[] = [];
  providers.forEach((Provider: any) => {
    const config = configs[Provider.configKey];
    if (config && config.enabled && !config.disable_js) {
      const wrapper = new ProviderWrapper({ log, provider: new Provider(config) });
      wrapper.load(snowplowHelper);
      activeProviders.push(wrapper);
    }
  });
  return activeProviders;
}
